import { SxProps } from '@mui/material';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { alpha, styled, useTheme } from '@mui/material/styles';

type TwoSidedSwitchProps = {
  leftSideText: string;
  rightSideText: string;
  twoSidedSwitchDisabledColour: string;
  sx?: SxProps;
  isRightSelected: boolean;
  onSwitchValueChanged: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  disabled: boolean;
};

const ColouredSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase + .MuiSwitch-track': {
    backgroundColor: theme.palette.secondary.main,
  },
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export default function TwoSidedSwitch(props: TwoSidedSwitchProps) {
  const {
    leftSideText,
    rightSideText,
    sx,
    twoSidedSwitchDisabledColour,
    isRightSelected,
    onSwitchValueChanged,
    disabled,
  } = props;
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={0.5}
      sx={[{
        alignItems: "center"
      }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Typography
        variant="button"
        color={isRightSelected ? twoSidedSwitchDisabledColour : theme.palette.secondary.main}
      >
        {leftSideText}
      </Typography>
      <ColouredSwitch
        value={isRightSelected}
        checked={isRightSelected}
        onChange={onSwitchValueChanged}
        disabled={disabled}
      />
      <Typography
        variant="button"
        color={
          isRightSelected && !disabled ? theme.palette.secondary.main : twoSidedSwitchDisabledColour
        }
      >
        {rightSideText}
      </Typography>
    </Stack>
  );
}
